import { render, staticRenderFns } from "./terms_conditions_page.vue?vue&type=template&id=d5fb2dd6&"
import script from "./terms_conditions_page.vue?vue&type=script&lang=js&"
export * from "./terms_conditions_page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports